export const notesPlansTabMeta = {
  id: "notes",
  label: "Ghi chú",
  shortLabel: "Note",
};
